import React, { useState, forwardRef, Ref, useCallback, useEffect } from 'react';
import { context } from '@gp/components/Context/index';
import StakeholderDetails from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderDetails';
import StakeholderEdit from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit';
import { PageMode } from '@gp/enums/common';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import '@gp/pages/Pipeline/ProjectDetails/Stakeholder/index.scss';

interface Props {
  pageContainer: React.RefObject<HTMLElement>;
  projectDetailData: any;
  detailAccessList: { [keyName: string]: boolean };
  onRefreshProjectDetails?: () => void;
  [keyName: string]: any;
}

interface ForwardProps {}

const Stakeholder = forwardRef((props: Props, ref: Ref<ForwardProps>) => {
  const { pageContainer, projectDetailData, detailAccessList, onRefreshProjectDetails } = props;

  const [pageMode, setPageMode] = useState<PageMode>(PageMode.Review);
  const [initialEditData, setInitialEditData] = useState(null);

  const handleEdit = useCallback((data: any) => {
    setInitialEditData(data);
    setPageMode(PageMode.Edit);
  }, []);

  const handleEditCancel = useCallback(() => {
    setPageMode(PageMode.Review);
  }, []);

  useEffect(() => {
    // 页面打点
    reportOperationLog({
      ...ALL_REPORT_OPERATION_LOG.PIPELINE_DETAIL_STAKEHOLDER,
      uidType: 'game_code',
      uid: projectDetailData?.project_id || '',
      extInfo: projectDetailData?.name,
    });
  }, []);

  return (
    <>
      <context.Provider value={{}}>
        <div className="dbg-detail-stakeholder-tab-content">
          {pageMode === PageMode.Review && (
            <StakeholderDetails
              pageContainer={pageContainer}
              projectDetailData={projectDetailData}
              isEditable={detailAccessList?.edit_stakeholder}
              onEdit={handleEdit}
              onRefreshProjectDetails={onRefreshProjectDetails}
            />
          )}
          {pageMode === PageMode.Edit && (
            <StakeholderEdit
              projectDetailData={projectDetailData}
              initialData={initialEditData}
              onCancel={handleEditCancel}
            />
          )}
        </div>
      </context.Provider>
    </>
  );
});

Stakeholder.defaultProps = {};

export default React.memo(Stakeholder);
